import None from './None';
export default function isMaybe(value) {
    var _a;
    return ((_a = value) === null || _a === void 0 ? void 0 : _a._kind) === 'Some' || value === None;
}
//# sourceMappingURL=isMaybe.js.map